import React from 'react';

import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormikInput from 'src/components/formik/FormikInput';
import * as Yup from 'yup';

function ContactForm({
  onSuccess,
}: any) {
  const fieldsConfig = [
    {
      name: 'firstName',
      component: () => (
        <FormikInput
          fullWidth
          label="First name"
          name="firstName"
        />
      ),
      gridProps: { xs: 12, md: 6 },
      validator: Yup.string().required('This field is required.'),
    },
    {
      name: 'lastName',
      component: () => (
        <FormikInput
          fullWidth
          label="Last name"
          name="lastName"
        />
      ),
      gridProps: { xs: 12, md: 6 },
      validator: Yup.string().required('This field is required.'),
    },
    {
      name: 'email',
      component: () => (
        <FormikInput
          fullWidth
          label="Email address"
          name="email"
          type="email"
        />
      ),
      validator: Yup.string().required('This field is required.'),
    },
  ];

  return (
    <CRUDConfigForm
      url="/automatic/contacts/"
      onSuccess={onSuccess}
      fieldsConfig={fieldsConfig}
      includeDeleteButton
    />
  );
}

export default ContactForm;
